import DeserializerUtils from './deserializer-utils';
import type { EntityData, JsonApi, Options } from './types';

class Deserializer {
  constructor(private readonly options: Options = {}) {}

  public deserialize = async <Data extends Record<string, unknown> | Record<string, unknown>[]>(
    jsonapi: JsonApi
  ): Promise<Data> => {
    // process as a collection - promise per entry
    if (Array.isArray(jsonapi.data)) {
      return Promise.all(
        jsonapi.data.map((data: EntityData) =>
          new DeserializerUtils(jsonapi, data, this.options).process()
        )
      ).then((result) => {
        const a = result;
        return a;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any;
    }

    // process the one object
    const result_3 = await new DeserializerUtils(
      jsonapi,
      jsonapi.data as EntityData,
      this.options
    ).process();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return result_3 as any;
  };
}

export default Deserializer;
